import React, { useRef, useEffect, useMemo } from 'react'
import { get, isEmpty, orderBy } from 'lodash'
import { Radio } from 'antd'
import ReactPlayer from 'react-player'
import { uploadPdf } from 'src/container/CMS/hooks.js'

import images from 'Themes/Images'
import ScheduleItem from '../../ScheduleItem'
import FileComponent from '../../FileComponent'
import { showError } from 'utils/notification'
import { SLIDE_TYPE } from 'utils/constants'
import { useDispatch, useSelector } from 'react-redux'
import { createAttachment, loadAttachment } from '../../../../../actions'
import { makeSelectAttachments } from '../../../../../selectors'
import UploadFileVideo from 'component/UploadFileVideo'
import UploadScormFile from 'component/UploadScormFile'
import { showGlobalLoading, hideGlobalLoading } from 'container/Modal/actions'
import ImageUploading from 'react-images-uploading'
import config from 'src/global-config'
import { getFileSize, downloadImage } from 'utils/helper'
import { fileToBase64 } from 'utils/helper'
import './styles.scss'
import { SUPPORTED_FORMATS_DOCUMENT_LESSON } from 'utils/constants'
import useGetTrainer from '../../../../../../../hooks/useGetTrainer'
import TextEditor from '../../../../../../../customs/ClassCompare/src/components/Editor'
import { CKEditorWrapper } from '../../../../../../CMS/screens/Article'
import { saveAs } from 'file-saver'

const AboutLesson = ({
  selectedSlide,
  formik,
  radio,
  setRadio,
  lessonType,
  videoUrl,
  setVideoUrl,
  imgUrl,
  setImgUrl,
  pdf,
  setPdf,
  schedules,
  listSchedules,
  setListSchedules,
  requiredSchedule,
  listImages,
  setListImages,
  setScormFileUrl,
  scormFileUrl,
  scormVersion,
  setScormVersion,
  ascendoDomain,
  wfaDomain,
  slideDetails,
  isBellDomain,
}) => {
  const refFile = useRef(null)
  const hiddenFileDoc = useRef(null)
  const dispatch = useDispatch()
  const attachments = useSelector(makeSelectAttachments())
  const { isTrainer } = useGetTrainer()
  const ids =
    listSchedules &&
    new Set(listSchedules.map(({ schedule_id }) => schedule_id))
  const newSchedules = schedules && schedules.filter(({ id }) => !ids.has(id))

  const maxNumber = 69

  const onChange = async (imageList, addUpdateIndex) => {
    await setListImages(imageList)
    formik.submitForm()
  }

  const handleClickFile = () => {
    if (refFile && refFile.current) {
      refFile.current.click()
    }
  }

  useEffect(() => {
    if (selectedSlide) {
      dispatch(loadAttachment())
    }
  }, [selectedSlide])

  const isHideAddScheduleButton = useMemo(
    () =>
      (selectedSlide?.questions?.length === 0 ||
        selectedSlide?.channel_id === 524) &&
      isBellDomain &&
      !!isTrainer,
    [selectedSlide, isBellDomain, isTrainer]
  )

  const handleClickFileDoc = () => {
    if (hiddenFileDoc.current) {
      hiddenFileDoc.current.click()
    }
  }
  const handleChangeFileDoc = async (event) => {
    dispatch(showGlobalLoading())
    const fileUploaded = event.target.files[0]
    if (
      !SUPPORTED_FORMATS_DOCUMENT_LESSON.includes(get(fileUploaded, 'type', ''))
    ) {
      dispatch(hideGlobalLoading())
      return formik.setFieldError(
        'presentation',
        'Please input the correct type, we just supported this type: PDF, PPT, PPTX'
      )
    }

    const pdf = await uploadPdf(fileUploaded)

    if (pdf) {
      setPdf(pdf)
    }
    dispatch(hideGlobalLoading())
  }

  const handleChangeFile = (event) => {
    const fileUploaded = event.target.files[0]
    if (fileUploaded) {
      const name = get(fileUploaded, 'name', '')

      fileToBase64(fileUploaded).then((result) => {
        if (result) {
          dispatch(
            createAttachment({
              name,
              attachment: result.split('base64,')[1],
            })
          )
        }
      })
    }
  }

  const getDownloadUrl = (url) => {
    if (!url) return ''
    const base = url.startsWith('http')
      ? url
      : `${config.baseUrl}${url.startsWith('/') ? '' : '/'}${url}`
    return base.includes('?')
      ? `${base}&download=true`
      : `${base}?download=true`
  }

  const handleDownloadPdf = () => {
    if (!pdf?.url || !pdf?.name) return
    const url = getDownloadUrl(pdf.url)
    return fetch(url, { method: 'GET' })
      .then((res) => res.blob())
      .then((blob) => {
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.setAttribute('download', pdf.name)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(link.href)
      })
      .catch(() => {
        saveAs(pdf.url, pdf.name)
      })
  }

  const handleDownloadImage = (image, index) => {
    const dataUrl = get(image, 'data_url', '')
    const name =
      get(image, 'file.name', '') ||
      get(image, 'name', '') ||
      `image-${index + 1}.png`
    if (!dataUrl) return
    downloadImage(dataUrl, name)
  }

  const handleDownloadScorm = () => {
    if (!scormFileUrl) return
    const url = getDownloadUrl(scormFileUrl)
    fetch(url, { method: 'GET' })
      .then((res) => res.blob())
      .then((blob) => {
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.setAttribute('download', 'scorm-package.zip')
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(link.href)
      })
      .catch(() => {})
  }

  const handleAddNewSchedule = () => {
    if (
      Array.isArray(listSchedules) &&
      Array.isArray(schedules) &&
      listSchedules.length === schedules.length
    ) {
      return showError('Please add a new schedule in the schedule page')
    }
    const emptySchedule = listSchedules.find((item) => !item.schedule_id)

    if (emptySchedule) {
      return showError('Please fill the empty schedule first!')
    }

    setListSchedules([...listSchedules, {}])
  }

  const renderAdditionalFile = () => {
    return (
      attachments &&
      orderBy(attachments, 'id', 'desc').map((item) => {
        return <FileComponent key={item.id} item={item} />
      })
    )
  }

  const renderByRadioButton = () => {
    let content = null

    switch (radio) {
      case SLIDE_TYPE.INFOGRAPHIC:
        content = (
          <div className="add-course__upload-wrap">
            <ImageUploading
              multiple
              value={listImages}
              onChange={onChange}
              maxNumber={maxNumber}
              dataURLKey="data_url"
            >
              {({
                imageList,
                onImageUpload,
                onImageRemoveAll,
                onImageUpdate,
                onImageRemove,
                isDragging,
                dragProps,
              }) => (
                <div className="upload__image-wrapper">
                  <div
                    className="upload__image-drag-select"
                    style={isDragging ? { background: '#e7ebf4' } : undefined}
                    onClick={onImageUpload}
                    {...dragProps}
                  >
                    <img src={images.upload} width="60" />
                    <div className="upload__image-title">
                      Drag and drop Images Here To Upload
                    </div>
                    <div className="upload__image-connect">Or</div>
                    <div className="upload__image-button">
                      Select Images to Upload
                    </div>
                  </div>

                  <span
                    className="upload__image-button"
                    onClick={onImageRemoveAll}
                    style={{ margin: '20px 0', display: 'inline-block' }}
                  >
                    Remove all images
                  </span>
                  <div className="upload__image-list-wrapper">
                    {imageList.map((image, index) => (
                      <div
                        className="upload__image-image-item-wrapper"
                        key={index}
                      >
                        <div className="upload__image-image-item-heading">
                          <div className="upload__image-image-item-title">
                            {get(image, 'file.name', '') ||
                              get(image, 'name', '')}
                          </div>
                          <div className="upload__image-image-item-size">
                            {getFileSize(
                              get(image, 'file.size', '') ||
                                get(image, 'size', '')
                            )}
                          </div>
                        </div>
                        <div
                          key={index}
                          className="upload__image-image-item"
                          onClick={() => onImageUpdate(index)}
                        >
                          <img src={image['data_url']} />
                        </div>
                        <div className="image-item__btn-wrapper">
                          <div
                            onClick={() => handleDownloadImage(image, index)}
                            className="upload__image-image-item-download"
                            title="Download"
                            style={{ marginRight: 30 }}
                          >
                            <img
                              src={images.admin.download}
                              className=""
                              alt="Download"
                            />
                          </div>
                          <div
                            onClick={async () => onImageRemove(index)}
                            className="upload__image-image-item-delete"
                          >
                            <img
                              src={images.admin.trash_icon}
                              className=""
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </ImageUploading>
          </div>
        )
        break
      case SLIDE_TYPE.VIDEO:
        content = (
          <>
            {videoUrl && (
              <div className="player-wrapper">
                <ReactPlayer
                  className="react-player"
                  url={videoUrl}
                  width="95%"
                  height="100%"
                  controls={true}
                />
              </div>
            )}
            <div className="add-lesson">
              <div className="add-lesson__upload" onClick={handleClickFileDoc}>
                <input
                  type="text"
                  name="vimeo"
                  className="add-lesson__input__link"
                  placeholder="Enter Youtube, Vimeo video link."
                  value={videoUrl}
                  onChange={(e) => setVideoUrl(e.currentTarget.value)}
                />
              </div>
            </div>

            {formik.errors.videoUrl && (
              <div className="form__error">{formik.errors.videoUrl}</div>
            )}
            <div style={{ marginTop: 15 }}>
              <UploadFileVideo setVideoUrl={setVideoUrl} />
            </div>
          </>
        )
        break
      case SLIDE_TYPE.STREAM:
        content = (
          <>
            <div className="add-lesson">
              <div className="add-lesson__upload" onClick={handleClickFileDoc}>
                <input
                  type="text"
                  name="stream"
                  className="add-lesson__input__link"
                  placeholder="Enter VidTags link"
                  value={formik.values.stream}
                  onChange={formik.handleChange}
                />
              </div>
            </div>
            {formik.errors.stream && (
              <div className="form__error">{formik.errors.stream}</div>
            )}
          </>
        )
        break
      case SLIDE_TYPE.PRESENTATION:
        content = (
          <>
            <div
              style={{
                width: '100%',
                border: '1px solid #e7ebf4',
                justifyContent: 'space-between',
                maxWidth: '100%',
                display: 'flex',
                alignItems: 'center',
                padding: '0 16px',
              }}
            >
              <div
                style={{
                  width: '350px',
                  height: '50px',
                  display: 'flex',
                  alignItems: 'center',
                  borderRadius: '4px',
                  cursor: 'pointer',
                }}
                onClick={handleClickFileDoc}
              >
                <img
                  src={
                    pdf
                      ? images.admin.document_upload_active
                      : images.admin.document_upload
                  }
                  alt=""
                />
                <input
                  type="file"
                  style={{ display: 'none' }}
                  ref={hiddenFileDoc}
                  onChange={handleChangeFileDoc}
                />
                <div className="add-lesson__text">
                  {pdf ? pdf.name : 'No file uploaded'}
                </div>
              </div>
              <div
                className="attachment__btn__wrapper"
                style={{ maxWidth: 500 }}
              >
                {pdf && (
                  <div
                    className="attachment__button-2"
                    style={{ marginRight: 15 }}
                  >
                    <a
                      className="btn__download"
                      type="button"
                      onClick={handleDownloadPdf}
                    >
                      <img src={images.admin.download} alt="" />
                      <span>Download</span>
                    </a>
                  </div>
                )}
                <div className="attachment__button" style={{ marginRight: 15 }}>
                  <button
                    className="tertiary-btn"
                    style={{ width: 90, padding: '8px 20px' }}
                    type="button"
                    onClick={handleClickFile}
                  >
                    Browse
                  </button>
                </div>
                <div style={{ cursor: 'pointer' }} onClick={() => setPdf(null)}>
                  <img src={images.admin.trash_icon} alt="" />
                </div>
              </div>
              {/* <div
                className="add-lesson__button"
                style={{ display: 'flex', alignItems: 'center', gap: 10 }}
              >
                <button
                  className="tertiary-btn"
                  type="button"
                  onClick={() => hiddenFileDoc.current.click()}
                >
                  Browse
                </button>
                {pdf && (
                  <button
                    type="button"
                    className="tertiary-btn"
                    onClick={handleDownloadPdf}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      cursor: 'pointer',
                      marginLeft: 0,
                      background: 'none',
                      border: 'none',
                    }}
                  >
                    <img src={images.admin.download} alt="" />
                    <span style={{ marginLeft: 4 }}>Download</span>
                  </button>
                )}
                <img
                  src={images.admin.trash_icon}
                  style={{ marginLeft: 0, cursor: 'pointer' }}
                  onClick={() => setPdf(null)}
                  alt="remove"
                />
              </div> */}
            </div>
            {formik.errors.presentation && (
              <div className="form__error">{formik.errors.presentation}</div>
            )}
          </>
        )
        break
      case SLIDE_TYPE.SCORM:
        content = (
          <>
            <div style={{ marginTop: 15 }}>
              <UploadScormFile
                setScormFileUrl={setScormFileUrl}
                scormFileUrl={scormFileUrl}
                scormVersion={scormVersion}
                setScormVersion={setScormVersion}
              />
              {/* {scormFileUrl && (
                <button
                  type="button"
                  className="tertiary-btn"
                  onClick={handleDownloadScorm}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                    marginLeft: 0,
                    background: 'none',
                    border: 'none',
                    marginTop: 10,
                  }}
                >
                  <img src={images.admin.download} alt="" />
                  <span style={{ marginLeft: 4 }}>Download</span>
                </button>
              )} */}
            </div>
          </>
        )
        break
      default:
        break
    }
    return content
  }

  return (
    <div className="about-lesson">
      {isEmpty(selectedSlide) ? <div className="about-lesson-overlay" /> : null}
      <div className="inner_container_2">
        <div className="add-course__description lessons__description">
          <div className="add-course__head" style={{ marginTop: 0 }}>
            DESCRIPTION
          </div>

          <CKEditorWrapper zIndex={100} top={77}>
            {formik.values.description || formik.values.description === '' ? (
              <TextEditor
                value={formik.values.description}
                onChange={(data) => formik.setFieldValue('description', data)}
              />
            ) : null}
          </CKEditorWrapper>

          {formik.touched.description && formik.errors.description && (
            <div className="form__error">{formik.errors.description}</div>
          )}
        </div>
        <div className="add-course__head">Content Upload</div>
        <div className={`lessons__types ${isTrainer ? 'disabledbutton' : ''}`}>
          <Radio.Group
            onChange={(e) => setRadio(e.target.value)}
            value={radio}
            name="add-course__radio-type"
          >
            {lessonType &&
              lessonType.map((type) => (
                <Radio key={type.id} value={type.id}>
                  {type.name}
                </Radio>
              ))}
          </Radio.Group>
        </div>
        <div className={`${isTrainer ? 'disabledbutton' : ''}`}>
          {renderByRadioButton()}
        </div>
        {selectedSlide && requiredSchedule && (
          <div className="lessons__tags">
            <div className="add-course__head">
              SCHEDULES (Add to limit the lesson to only students enrolled in
              these schedules)
            </div>
            {listSchedules &&
              schedules &&
              orderBy(listSchedules, 'id', 'asc').map((item, index) => (
                <ScheduleItem
                  key={index}
                  dispatch={dispatch}
                  item={item}
                  index={index}
                  schedules={schedules}
                  listSchedules={listSchedules}
                  setListSchedules={setListSchedules}
                  newSchedules={newSchedules}
                  formik={formik}
                />
              ))}

            {!isHideAddScheduleButton && (
              <div
                className="lessons__attachments__add"
                onClick={handleAddNewSchedule}
              >
                <img src={images.admin.plus_normal} alt="" /> ADD A SCHEDULE
              </div>
            )}
          </div>
        )}

        <div className="lessons__attachments" style={{ marginTop: 25 }}>
          <div className="lessons__attachments__text">
            Lesson Downloads (Optional)
          </div>
          <div className="lessons__attachments__desc">
            Share or upload supplementary materials for students to refer and
            follow along with your lesson.
          </div>
          <div className="lessons__attachments__warning">
            <img src={images.admin.warning} alt="" /> File sizes limit up to
            10MB. Only JPG, PNG PDF, DOCX and XLS accepted.
          </div>
          {renderAdditionalFile()}

          {selectedSlide && !isTrainer && (
            <>
              <input
                type="file"
                style={{ display: 'none' }}
                ref={refFile}
                onChange={handleChangeFile}
              />
              <div
                className="lessons__attachments__add"
                onClick={handleClickFile}
              >
                <img src={images.admin.plus_normal} alt="" /> ADD A FILE
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default AboutLesson
